import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-1 flex-col overflow-hidden bg-catering-cream-100" }
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { class: "flex-1 overflow-y-auto px-2 pb-3" }
const _hoisted_4 = {
  key: 0,
  class: "px-2 py-6 text-center text-sm text-catering-ink-500"
}
const _hoisted_5 = {
  key: 1,
  class: "px-2 py-6 text-center text-sm text-catering-ink-500"
}
const _hoisted_6 = {
  key: 2,
  class: "space-y-1"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "block truncate text-sm text-catering-ink-900" }
const _hoisted_9 = { class: "text-xs text-catering-ink-400" }
const _hoisted_10 = ["onKeydown", "onBlur"]
const _hoisted_11 = { class: "ml-2 flex shrink-0 items-center gap-1 opacity-0 group-hover:opacity-100" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 3,
  class: "mt-2 text-center"
}

import { computed, ref } from 'vue'
import { PencilIcon, TrashIcon } from '@heroicons/vue/24/outline'
import { filterConversations, debounce, historyEmptyState, commitRenameTitle } from '@/helpers/botHistory'
import { timeAgo } from '@/helpers/timeAgo'
import { botWidgetCopy } from '@/config/botWidgetCopy'


export default {
  __name: 'BotHistory',
  props: {
  conversations: { type: Array, default: () => [] },
  cursor: { type: String, default: null },
  platform: { type: String, default: 'catering' }
},
  emits: ['open', 'rename', 'delete', 'load-more'],
  setup(__props, { emit: __emit }) {

const props = __props
const historyEmpty = computed(() => botWidgetCopy(props.platform).historyEmpty)
const emit = __emit
const query = ref('')
const appliedQuery = ref('')
const editingId = ref(null)
const draftTitle = ref('')
const applyQuery = debounce(v => (appliedQuery.value = v), 200)
const onSearch = () => applyQuery(query.value)
const filtered = computed(() => filterConversations(props.conversations, appliedQuery.value))
const emptyState = computed(() =>
  historyEmptyState({ total: props.conversations.length, query: appliedQuery.value, filtered: filtered.value.length })
)
const ago = timeAgo
const startRename = c => {
  editingId.value = c.id
  draftTitle.value = c.title || ''
}
const commitRename = c => {
  if (editingId.value !== c.id) return
  const title = commitRenameTitle(draftTitle.value, c.title)
  if (title) emit('rename', { id: c.id, title })
  editingId.value = null
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((query).value = $event)),
        type: "search",
        "aria-label": "Search chats",
        placeholder: "Search chats…",
        class: "w-full rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 px-3 py-1.5 text-sm text-catering-ink-900 placeholder:text-catering-ink-400 focus:ring-0",
        onInput: onSearch
      }, null, 544), [
        [_vModelText, query.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (emptyState.value === 'first-run')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(historyEmpty.value), 1))
        : (emptyState.value === 'no-results')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " No chats match “" + _toDisplayString(query.value) + "”. ", 1))
          : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (c) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: c.id,
                  class: "group flex items-center justify-between rounded-catering-md px-2 py-2 hover:bg-catering-cream-200"
                }, [
                  (editingId.value !== c.id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "min-w-0 flex-1 text-left",
                        onClick: $event => (_ctx.$emit('open', c.id))
                      }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(c.title || 'Untitled chat'), 1),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(ago)(c.last_message_at)), 1)
                      ], 8, _hoisted_7))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((draftTitle).value = $event)),
                        class: "min-w-0 flex-1 rounded border border-catering-cream-300 bg-catering-cream-50 px-2 py-1 text-sm text-catering-ink-900",
                        onKeydown: [
                          _withKeys($event => (commitRename(c)), ["enter"]),
                          _cache[2] || (_cache[2] = _withKeys($event => (editingId.value = null), ["esc"]))
                        ],
                        onBlur: $event => (commitRename(c))
                      }, null, 40, _hoisted_10)), [
                        [_vModelText, draftTitle.value]
                      ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Rename chat",
                      class: "p-1 text-catering-ink-500 hover:text-catering-ink-900",
                      onClick: $event => (startRename(c))
                    }, [
                      _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                    ], 8, _hoisted_12),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Delete chat",
                      class: "p-1 text-catering-ink-500 hover:text-catering-berry-500",
                      onClick: $event => (_ctx.$emit('delete', c.id))
                    }, [
                      _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                    ], 8, _hoisted_13)
                  ])
                ]))
              }), 128))
            ])),
      (__props.cursor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "text-xs text-catering-ink-500 hover:text-catering-ink-700",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('load-more')))
            }, " Load more ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}